import { render, staticRenderFns } from "./ClassManage.vue?vue&type=template&id=4e488c31&scoped=true"
import script from "./ClassManage.vue?vue&type=script&lang=js"
export * from "./ClassManage.vue?vue&type=script&lang=js"
import style0 from "./ClassManage.vue?vue&type=style&index=0&id=4e488c31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e488c31",
  null
  
)

export default component.exports